const processInclude = require('./util');

$(document).ready(() => {
    processInclude(require('../../../../../plugin_giftregistry/cartridge/client/default/js/giftRegistry'));
});
